import React, { Fragment } from 'react';
import classNames from 'classnames';

import {
  withSettings,
  IWithSettingsProps,
} from '../../../../../components/context/settings';
import { withTPA, IWithTPAProps } from '../../../../../components/context/tpa';
import {
  withI18n,
  IWithI18nProps,
} from '../../../../../components/context/i18n';

import SearchIcon from '../../../../../components/ui/icons/SearchIcon';

import compose from '../../../../../lib/utils/compose';

import getStyles from './EpisodesSearch.styles';
import styles from './EpisodesSearch.scss';
import { EpisodesLayout } from '@wix/podcasts-common/dist/settings';

interface IEpisodesSearchProps
  extends IWithSettingsProps,
    IWithTPAProps,
    IWithI18nProps {
  query: string;
  minimized: boolean;
  autoFocus: boolean;

  onSearch(query: string): void;
  onFocus(): void;
  onBlur(): void;
}

class EpisodesSearch extends React.Component<IEpisodesSearchProps> {
  private inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  handleChange = () => {
    const query = this.inputRef.current.value;

    this.props.onSearch(query);
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.handleChange();
  };

  handleReset = (event) => {
    // Do not send "click" event to form
    event.stopPropagation();

    this.inputRef.current.value = '';
    this.props.onSearch('');
  };

  render() {
    const { query, settings, tpa, t, onFocus, onBlur, minimized, autoFocus } =
      this.props;

    const dynamicStyles = getStyles({
      colors: settings.colors.main,
      fonts: settings.fonts.main,
      deviceType: tpa.params.deviceType,
      mainSettings: settings.main,
    });

    const isGridLayout = settings.main.episodesLayout === EpisodesLayout.GRID;

    return (
      <form
        data-hook="main.episodes.search-form"
        className={classNames(styles.search, {
          [styles.grid]: isGridLayout,
          [styles.fullWidth]: !minimized,
        })}
        onSubmit={this.handleSubmit}
        onClick={onFocus}
        noValidate
      >
        <div className={styles.searchInputWrapper}>
          <SearchIcon
            className={classNames(styles.searchIcon, dynamicStyles.searchIcon)}
          />
          {!minimized && (
            <Fragment>
              <input
                data-hook="main.episodes.search-input"
                ref={this.inputRef}
                className={classNames(
                  styles.searchInput,
                  dynamicStyles.searchInput,
                )}
                type="text"
                placeholder={t('pages.main.search.input-placeholder')}
                value={query}
                onChange={this.handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                autoFocus={autoFocus}
                required
              />
              <button
                data-hook="main.episodes.search-input-reset"
                className={classNames(
                  styles.resetButton,
                  dynamicStyles.resetButton,
                )}
                type="button"
                onClick={this.handleReset}
              >
                ✕
              </button>
            </Fragment>
          )}
        </div>
      </form>
    );
  }
}

export default compose(withSettings, withTPA, withI18n)(EpisodesSearch);
